export default function permissionsReducer (state = null, action) {
  switch (action.type) {
    case 'SET_PERMISSIONS':
      return action.payload;
    default:
      return state;
  }
};